export default __webpack_public_path__ + "static/media/Privacy.6a52c6ef.svg";